import * as d3 from 'd3';
import Axis from './Axis.js';

export default class YearAxis extends Axis {
  constructor(props) {
    super(props);

    this.axis = d3.axisBottom(this.xScale).ticks(d3.timeYear.every(1));
  }

  removeText() {
    const { chart } = this.props;

    chart.selectAll('.year .tick text').remove();

    return this;
  }

  addYearGrid() {
    const {
      chart,
      options: { height },
    } = this.props;
    chart
      .selectAll('.year .tick')
      .select('line')
      .transition()
      .duration(0)
      .attr('stroke-dasharray', false)
      .attr('y2', height);

    return this;
  }

  removeDomainPath() {
    const { chart } = this.props;

    chart.select('.year .domain').remove();

    return this;
  }

  update() {
    const { chart } = this.props;

    this.axis.scale(this.xScale);

    chart
      .select('.axis.year')
      .transition()
      .duration(this.transitionDuration)
      .call(this.axis);

    this.removeText().addYearGrid().removeDomainPath();
  }

  build() {
    const { chart } = this.props;

    chart
      .append('g')
      .attr('class', 'axis year')
      .attr('transform', 'translate(0,0)')
      .call(this.axis);

    this.removeText().addYearGrid().removeDomainPath();
  }
}
